/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S11_Li5_TextInputs */

const tr_onbilgi_s11_li5_text = /** @type {(inputs: Onbilgi_S11_Li5_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform; QNB eSolutions e-Fatura, Sipay Sanal POS, Cloudflare Workers altyapısı ve Supabase PostgreSQL üzerinde çalışır. Üçüncü taraf entegrasyonlar (Trendyol, Shopify, Hepsiburada, n11, Geliver) sağlayıcının resmi API'leri üzerinden yapılır.`)
};

const en_onbilgi_s11_li5_text = /** @type {(inputs: Onbilgi_S11_Li5_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Platform runs on QNB eSolutions e-Fatura, Sipay Sanal POS, the Cloudflare Workers infrastructure and Supabase PostgreSQL. Third party integrations (Trendyol, Shopify, Hepsiburada, n11, Geliver) are carried out through the official APIs of the respective provider.`)
};

const de_onbilgi_s11_li5_text = /** @type {(inputs: Onbilgi_S11_Li5_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Plattform läuft auf QNB eSolutions e-Fatura, Sipay Sanal POS, der Cloudflare-Workers-Infrastruktur und Supabase PostgreSQL. Integrationen von Drittanbietern (Trendyol, Shopify, Hepsiburada, n11, Geliver) erfolgen über die offiziellen APIs des jeweiligen Anbieters.`)
};

const ru_onbilgi_s11_li5_text = /** @type {(inputs: Onbilgi_S11_Li5_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платформа работает на базе QNB eSolutions e-Fatura, Sipay Sanal POS, инфраструктуры Cloudflare Workers и Supabase PostgreSQL. Интеграции сторонних сервисов (Trendyol, Shopify, Hepsiburada, n11, Geliver) выполняются через официальные API соответствующего поставщика.`)
};

/**
* | output |
* | --- |
* | "The Platform runs on QNB eSolutions e-Fatura, Sipay Sanal POS, the Cloudflare Workers infrastructure and Supabase PostgreSQL. Third party integrations (Trend..." |
*
* @param {Onbilgi_S11_Li5_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s11_li5_text = /** @type {((inputs?: Onbilgi_S11_Li5_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S11_Li5_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s11_li5_text(inputs)
	if (locale === "de") return de_onbilgi_s11_li5_text(inputs)
	if (locale === "ru") return ru_onbilgi_s11_li5_text(inputs)
	return tr_onbilgi_s11_li5_text(inputs)
});